<script>
import CurrentUser from './CurrentUser'
window.CurrentUser = CurrentUser
import Api from './Api'

export default {

  computed: {
    userName() {
      let user = CurrentUser.get(Api.defaultEnvironment)
      if (user) {
        return user.first_name
      }
      return ''
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-content">
      <div class="media">
        <img src="../assets/luna.png" class="luna-image" alt="Picture of Luna">
      </div>

      <div class="content">
        <p>Hi!</p>
        <p>
          My name is Luna. I am a blue and lovely monkey. As you might have guessed from my name, I have been on the moon.<br>
          I therefore know how hard it is to test a lot of complicated stuff before it goes into production.
        </p>
        <p>
          But, I have good news! I'm here to help you with all the repetitive tasks that you would usually do manually over and over again.
        </p>
        <p>
          I will help you setup everything. From providers and teams to cars and drivers. Plus a lot more. And everything in between.
        </p>
        <p>
          Thus you can concentrate on something that's more interesting for you ;)
        </p>

        <p>
          Best,
        </p>

        <div class="columns">
          <div class="column">
            <img src="../assets/sign.png" class="luna-image" alt="Signature of Luna">
          </div>
          <div class="column has-text-right">

            <audio @click="showCredits = true" controls>
              <source src="../assets/luna.mp3" type="audio/mpeg">
            </audio>

            <p class="is-size-7">
              Watch the full Starman video
              <a href="https://www.youtube.com/watch?v=tRcPA7Fzebw" target="_blank" rel="nofollow">here</a>
            </p>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.luna-image {
  max-height: 100px;
}
.media .luna-image {
  margin: auto;
}

</style>